import React from 'react';
interface LogoProps {
  /** Wordmark size; the mark scales with it. */
  size?: 'sm' | 'md';
}
export function Logo({
  size = 'md'
}: LogoProps) {
  const wordClass = size === 'sm' ? 'text-lg' : 'text-xl';
  const markClass = size === 'sm' ? 'h-5 w-5' : 'h-6 w-6';
  return <span className="inline-flex items-center gap-2" data-id="element-143" data-mp="3v8nwpsjblwho">
      <span className={`${wordClass} font-extrabold tracking-[0.1em] text-heading`} data-id="element-144" data-mp="3v97e98526iv6">
        ZIA<span className="text-accent-ink" data-id="element-145" data-mp="mu5u46c5f95g">XEN</span>
      </span>
      <img src="https://cdn.magicpatterns.com/uploads/odRA6yL239yeNSNgsQZQr7/IMG-20250621-WA0013.jpg" alt="Ziaxen mark" className={`logo-mark ${markClass} shrink-0 object-contain`} data-id="element-146" data-mp="rrp6t1t77dva" />
    </span>;
}